
import { ErrorMessage } from '@hookform/error-message';

const Errormessages = ({ errors, name }: any) => (

    <ErrorMessage
        errors={errors}
        name={name}
        render={({ message }) => <p className='text-danger'>{message}</p>}
    />
);

export default Errormessages;
